import type { FilaJukebox, PlaylistItem, MusicaAtualBroadcast } from '@/shared/types';

export type FaixaAtual = {
  videoId: string;
  titulo: string;
  thumbnail: string;
  origem: 'pedido' | 'playlist';
  isInvasaoTematica: boolean;
} | null;

/** Resolve a faixa em exibição: pedido do cliente tem prioridade sobre o item da playlist. */
export function resolverFaixaAtual(
  pedidoAtual: FilaJukebox | null | undefined,
  itemPlaylist: PlaylistItem | null | undefined,
): FaixaAtual {
  if (pedidoAtual) {
    const videoId = pedidoAtual.youtube_video_id?.trim() ?? '';
    if (!videoId) return null;
    return {
      videoId,
      titulo: pedidoAtual.titulo,
      thumbnail: pedidoAtual.thumbnail,
      origem: 'pedido',
      isInvasaoTematica: pedidoAtual.is_invasao_tematica ?? false,
    };
  }

  if (itemPlaylist) {
    const videoId = itemPlaylist.video_id?.trim() ?? '';
    if (!videoId) return null;
    return {
      videoId,
      titulo: itemPlaylist.titulo,
      thumbnail: itemPlaylist.thumbnail,
      origem: 'playlist',
      isInvasaoTematica: false,
    };
  }

  return null;
}

export function montarMusicaAtualBroadcast(
  faixa: FaixaAtual,
  extras: { duracao_segundos: number | null; iniciada_em?: string },
): MusicaAtualBroadcast | null {
  if (!faixa) return null;
  return {
    youtube_video_id: faixa.videoId,
    titulo: faixa.titulo,
    thumbnail: faixa.thumbnail,
    duracao_segundos: extras.duracao_segundos,
    iniciada_em: extras.iniciada_em,
    is_invasao_tematica: faixa.isInvasaoTematica,
  };
}
